import { render } from "./RestaurantDetails.vue?vue&type=template&id=a377eb40&scoped=true"
import script from "./RestaurantDetails.vue?vue&type=script&lang=js"
export * from "./RestaurantDetails.vue?vue&type=script&lang=js"

import "./RestaurantDetails.vue?vue&type=style&index=0&id=a377eb40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a377eb40"]])

export default __exports__